import {Injectable} from '@angular/core';
import {BaseOPEService} from "./BaseOPEService";
import {GetDeviceTypesCB} from "../../ope/device-type/GetDeviceTypesCB";
import {GetDeviceTypeCB} from "../../ope/device-type/GetDeviceTypeCB";
import {PutDeviceTypeCB} from "../../ope/device-type/PutDeviceTypeCB";
import {DelDeviceTypeCB} from "../../ope/device-type/DelDeviceTypeCB";
import {DuplicateDeviceTypeCB} from "../../ope/device-type/DuplicateDeviceTypeCB";
import {GetManufacturersCB} from "../../ope/manufacturer/GetManufacturersCB";
import {DelManufacturerCB} from "../../ope/manufacturer/DelManufacturerCB";
import {GetDataUnitsCB} from "../../ope/data-unit/GetDataUnitsCB";
import {DelDataUnitCB} from "../../ope/data-unit/DelDataUnitCB";

@Injectable({
  providedIn: 'root'
})
export class DeviceTypeOpeService extends BaseOPEService {

  public getDeviceTypes(cb: GetDeviceTypesCB): Promise<any> {
    return this.execOPE(cb);
  }

  public getDeviceType(cb: GetDeviceTypeCB): Promise<any> {
    return this.execOPE(cb);
  }

  public putDeviceType(cb: PutDeviceTypeCB): Promise<any> {
    return this.execOPE(cb);
  }

  public delDeviceType(cb: DelDeviceTypeCB): Promise<any> {
    return this.execOPE(cb);
  }

  public duplicateDeviceType(cb: DuplicateDeviceTypeCB): Promise<any> {
    return this.execOPE(cb);
  }

  public getManufacturers(cb: GetManufacturersCB): Promise<any> {
    return this.execOPE(cb);
  }

  public delManufacturer(cb: DelManufacturerCB): Promise<any> {
    return this.execOPE(cb);
  }

  public getDataUnits(cb: GetDataUnitsCB): Promise<any> {
    return this.execOPE(cb);
  }

  public delDataUnit(cb: DelDataUnitCB): Promise<any> {
    return this.execOPE(cb);
  }

}
